import { ElementRef, Input, Component, OnInit, } from '@angular/core';
import { AuthService } from '../_services';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';


import { Broadcaster } from 'environments/broadcaster';


import { Subscription } from 'rxjs/Subscription';
import { LoaderService } from '../_services/loader.service';
import Swal from 'sweetalert2'


declare var $: any;


@Component({
  selector: 'new-consumerLko',
  templateUrl: 'newConsumerLko.component.html',
})


export class NewConsumerLkoDirective implements OnInit {
  public busy: Subscription;
  @Input() consumer: any;
  public showLoader: boolean;
  public consumers: any
  prjId: any
  userId: any
  consumerModal: any
  zoneList: any
  wardList: any
  categoryList: any
  subCategoryList: any
  imgLoaderPath: any
  gettingCustomerId: any


  constructor(private broadcaster: Broadcaster, private _el: ElementRef, private auth: AuthService, private http: HttpClient, private loaderService: LoaderService) {

    this.broadcaster.on('addnewConsumerLKO').subscribe(message => {
      if (message) {
        this.getCustomerDetail(message)
      }
      else {
        $('#coustomerModal').modal('show');
        this.consumerModal = {}
        this.getConsumersCode()



      }
    });
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val;
    });
  }

  getConsumersCode() {
    var source = "W"
    if (this.consumerModal.CustomerId == null || this.consumerModal.CustomerId == undefined || this.consumerModal.CustomerId == '') {
      this.gettingCustomerId = true;
      this.imgLoaderPath = "../../assets/img/loading.gif";
    }
    this.http.get(environment.apiUrl + 'lko/generateCustomerId?Prjid=' + this.prjId + '&userId=' + this.userId + '&source=' + source).subscribe(data => {
      var result: any
      result = data
      this.consumerModal.CustomerId = result.ConsumerCode;
      this.imgLoaderPath = "../../assets/img/ok.png";
    });
  }
  getCustomerDetail(customerId) {
    this.http.get(environment.apiUrl + 'lko/getCustomerById?customerId=' + customerId).subscribe(data => {
      var result: any
      result = data
      result.ZoneId = JSON.stringify(result.ZoneId)
      result.WardId = JSON.stringify(result.WardId)
      result.BLDTypeId = JSON.stringify(result.BLDTypeId)
      result.UCCCATID = JSON.stringify(result.UCCCATID)
      this.consumerModal = result;
      this.selectCategory({ id: JSON.parse(result.BLDTypeId) })
      this.selectZone({ id: result.ZoneId })
      $('#coustomerModal').modal('show');
    });
  }

  validateData(data) {
    if (!data.CustomerName) {
      Swal("", "Please type customer name !", "error");
      return false
    } else if (!data.ZoneId) {
      Swal("", "Please Select Zone !", "error");
      return false
    } else if (!data.UCCCATID) {
      Swal("", "Please Select UCC Sub Category !", "error");
      return false
    } else if (!data.BLDTypeId) {
      Swal("", "Please Select UCC Category !", "error");
      return false
    } else if (!data.BillingAmount) {
      Swal("", "Please type billing amount !", "error");
      return false
    } else {
      return true
    }

  }
  saveCustomer() {

    if (!this.validateData(this.consumerModal)) {
      return;
    }
    this.consumerModal.UserId = this.userId
    this.http.post(environment.apiUrl + 'lko/saveCustomer', this.consumerModal).subscribe(data => {
      Swal({
        text: "Consumer Saved / Updated successfully"
      });
      $('#coustomerModal').modal('hide');
      this.broadcaster.broadcast('consumerSavedLKO', "");

    });

  }



  getAllZone() {
    this.http.get(environment.apiUrl + 'consumer/getZoneByProject?prjid=' + this.prjId + '&oemid=7').subscribe(data => {
      this.zoneList = data;
    });
  }


  selectZone(data) {

    // console.log(data)
    this.http.get(environment.apiUrl + "consumer/getZoneByProject?prjid=" + this.prjId + "&oemid=8&entityid=" + data.id).subscribe(data => {
      this.wardList = data;
    });

  }

  getCategory() {
    this.http.get(environment.apiUrl + 'consumer/getConsumerBuildingCategoty?prjId=' + this.prjId).subscribe(data => {
      this.categoryList = data;
    });
  }


  selectCategory(data) {
    // console.log("data",data)
    this.http.get(environment.apiUrl + 'consumer/getUccTypeByCatId?categoryId=' + data.id + '&prjId=' + this.prjId).subscribe(data => {
      this.subCategoryList = data;
    });
  }


  ngOnInit() {
    this.prjId = this.auth.getAuthentication().projectId
    this.userId = this.auth.getAuthentication().id
    this.getAllZone()
    this.getCategory()


  }
}




// WEBPACK FOOTER //
// ./src/app/_directives/newConsumerLko.component.ts